import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AvForm, AvGroup, AvField, AvRadioGroup, AvRadio, AvInput, AvFeedback } from 'availity-reactstrap-validation';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import { post } from "../../helpers/api_helper";
import { registerUserSuccessful } from "../../store/actions";
import statecity from '../../assets/jsons/statecity.json'
import statecity1 from '../../assets/jsons/statecity1.json'
import { AiOutlineCloudUpload } from 'react-icons/ai';
import { toast } from "react-toastify";

const PageOne = (props) => {
  const [email, setEmail] = useState(null);
  const [nextStep, setNextStep] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] =useState("");
  const [cityOptions, setCityOptions] = useState([]);
  const [sateData, setStateData] = useState([]);
  const [adhar, setAdhar] = useState("");
  const [panCard, setPanCard] = useState("");
  const [error, setError] = useState(false);
  useEffect(()=>{
    getEmail();

  }, []);
  useEffect(()=>{
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  },[])

   useEffect(()=>{
    // console.log('statecity1',statecity1);
    setStateData(statecity1)
   },[sateData])

  useEffect(()=>{
    if(selectedState){
    const city = sateData.findIndex(x=>x.name == selectedState);
    // console.log('city',city);
    // let cities = [];
    // city.map((item)=>{
    //   cities.push(item);
    // });
    setCityOptions(sateData[city]?.cities);
    // console.log('cities',city);
    }
  }, [selectedState]);

  const getEmail=async()=>{
    var data = await localStorage.getItem("authUser");
    if(data){
      data=JSON.parse(data);
      setEmail(data?.email);
    }
  }

  // console.log('selectedState',selectedState)

  const handleValidSubmit = (event, values) => {

    const body = {
      ...values,
      step:2,
      email:props.email
    }
    // console.log('step 1 before',values);
    let   regex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

    if(regex.test(panCard)) {

      post('/register', body)
      .then((json => {
        // console.log('PERSONAL DETAILS',json);
        if(json.statusCode==200){
          toast.success(json.message);
          props.onButtonClick("pagetwo");
          props.registerUserSuccessful(json);

        }else{
          toast.error(json.error);
        }
      }))
        //  setError(false);


    }else{
    // setError(true)
    toast.error('Incorrect Pan!');
  }
  }



  const adharValue = async (e) => {
//  console.log('event ',e.key)
   if(e.key === 'Backspace'){
    if (e.target.value.length === 5) {
      e.target.value += ' '
  } else if (e.target.value.length === 10) {
      e.target.value += ' '
  }
   }else{
    if (e.target.value.length === 4) {
      e.target.value += ' '
  } else if (e.target.value.length === 9) {
      e.target.value += ' '
  }
   }

    setAdhar(e.target.value)
}

 const pancardValidation = (e) => {
  const cardN = e.target.value.toUpperCase();

  setPanCard(cardN)
//  return false

}

const backFunction = () =>{

  props.nextStepFunc(false)
}

  // console.log('panCard',panCard);

  return (

    <>
      <AvForm
      onValidSubmit={(e, v) => {
        handleValidSubmit(e, v)
      }}
    >
      <Row>
        <Col lg={12}>
          <h3 className="heading-title">Personal Details</h3>
        </Col>
        <Col md={4} sm={6}>
          <AvField type="text" name="registeredNo" label={props.apptype == "NATS" ? "NATS Registration No.":"NAPS Registration No."}  required/>
        </Col>
        {/* <Col md={4} sm={6}>
        <AvField type="select" name="userType" label="User Type">
          <option>Select type</option>
          <option value="Student Pursuing">Student Pursuing</option>
          <option value="Student Complete">Student Complete</option>
          <option value="Experienced">Experienced</option>
        </AvField>
        </Col> */}
        {/* <Col md={4} sm={6}>
          <AvField type="text" name="name" label="Full Name"  />
        </Col> */}
        <Col md={4} sm={6}>
          <AvField type="text" name="fName" label="Father Name"  required />
        </Col>
        <Col md={4} sm={6}>
          <AvField type="text" name="mName" label="Mother's Name"  required />
        </Col>
        <Col md={4} sm={6}>
          <div className="child-field-form">
           <div className="field-1 field">
           <AvField type="text" value={adhar}
           validate={{maxLength: {value: 14}}}
           onChange={adharValue}
           name="adharNo" label="Aadhar No"  required />
           </div>
           {/* <div className="field-3 field">
            <Label className="choose_l">Choose File(optional)</Label>
            <AvGroup>
            <Label for="Aadhar_Copy" className="Aadhar_Copy">

            <AiOutlineCloudUpload />

          </Label>
          <AvInput type="file" name="adharAtt" id="Aadhar_Copy" />
          <AvFeedback>This is an error!</AvFeedback>
        </AvGroup>
          </div> */}
          </div>
        </Col>
        <Col md={4} sm={6}>
          <div className="child-field-form">
           <div className="field-1 field">
           <AvField type="text"
           onChange={pancardValidation}
           value={panCard}
           validate={{maxLength: {value: 10}}}
            name="panNo" label="PAN No" required  />
           </div>
           {error == true ? <span>! Incorrect Pan</span>:null}
           {/* <div className="field-3 field">
           <Label className="choose_l">Choose File(optional)</Label>
            <AvGroup>
            <Label for="Pan_Copy" className="Aadhar_Copy">

            <AiOutlineCloudUpload />

          </Label>
          <AvInput type="file" name="adharAtt" id="Pan_Copy" />
          <AvFeedback>This is an error!</AvFeedback>
          {error == true ? <span>! Incorrect Pan</span>:null}
        </AvGroup>
          </div> */}
          </div>
        </Col>

        <Col md={4} sm={6}>
          <AvField type="text" name="mobile" label="Candidate's Mobile No."  required/>
        </Col>
        <Col md={4} sm={6}>
          <AvField type="text" name="mobileR" label="Guardian Mobile No." required/>
        </Col>
        <Col md={4} sm={6}>
          <AvField type="text" name="relativeRelation" label="Guardian Relational" required/>
        </Col>
         <Col md={4} sm={6}>
          <AvField type="text" name="relativeName" label="Guardian Name" required/>
        </Col>
        <Col md={4} sm={6}>
          <AvField
            id="dob"
            name="dob"
            placeholder="Date of Birth"
            type="date"
            label="Date of Birth"
            required
            validate={{ max: { value: new Date() } }}
          />
        </Col>

        <Col md={4} sm={6}>
        <AvField type="select" name="state"

        onChange={e => setSelectedState(e.target.value)}
        label="Select State" required>
          <option>Select State</option>
          {
            sateData.map((item)=>
            <>
             <option value={item?.name}>{item?.name}</option>
            </>
            )

          }

        </AvField>
        </Col>
        <Col md={4} sm={6}>
          <AvField type="select" name="city" label="Select City" required>
             <option>Select City</option>
             {
              cityOptions.map((item)=>
              <>
             <option value={item?.name}>{item?.name}</option>
            </>
              )
             }
          </AvField>
        </Col>
        <Col md={4} sm={6}>
          <AvField type="text" name="pincode" validate={{maxLength: {value:6}}} label="Pin Code" required />
        </Col>
        <Col md={8} sm={6}>
          <AvField
            id="address"
            name="address"
            type="textarea"
            label="Address"

            rows={1}
          />
        </Col>
        <Col md={4} sm={6}>
          <AvField type="text" name="landmark" label="Landmark Address" required />
        </Col>
        <Col md={4} sm={6}>
          <AvRadioGroup inline name="cast" label="Category" className="bgremove" required>
            <AvRadio label="SC" value="SC" />
            <AvRadio label="ST" value="ST" />
            <AvRadio label="OBC" value="OBC" />
            <AvRadio label="GEN" value="GEN" />

          </AvRadioGroup>
        </Col>
        <Col md={4} sm={6}>
          <AvRadioGroup inline name="gender" label="Gender" className="bgremove" required>
            <AvRadio label="Male" value="male" />
            <AvRadio label="Female" value="female" />
            <AvRadio label="Transgender" value="rnts" />

          </AvRadioGroup>
        </Col>


        <FormGroup className="btn_box">
        <Button
            onClick={backFunction}
            className="common-btn">Back</Button>
        <Button
          // onClick={() => props.onButtonClick("pagetwo")}
          type="submit"
          className="common-btn">Next</Button>
        </FormGroup>
      </Row>
    </AvForm>

    </>
  );
};

export default PageOne;
